document.addEventListener('DOMContentLoaded', function () {
    const quizData = [
        {
            id: 1,
            question: "When do your cravings hit the hardest?",
            image: "https://cdn.shopify.com/s/files/1/0053/0097/7710/files/Img_1.jpg?v=1772138063",
            options: [
                { text: "In social settings; restaurants, parties, or around shared food", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "When I'm anxious, overwhelmed, or can't sit still", scores: { calocurb: 0, sculpt: 2, gutglow: 0 } },
                { text: "After meals; I'm full but still want something", scores: { calocurb: 0, sculpt: 0, gutglow: 1 } },
                { text: "Randomly throughout the day; cravings feel impulsive & strong", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "I rarely have cravings", scores: { calocurb: 0, sculpt: 0, gutglow: 0 } }
            ]
        },
        {
            id: 2,
            question: "After you eat, how do you usually feel?",
            image: "https://cdn.shopify.com/s/files/1/0053/0097/7710/files/2.jpg?v=1772138062",
            options: [
                { text: "Still hungry or not fully satisfied", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "Full but mentally restless; I still want something else", scores: { calocurb: 0, sculpt: 2, gutglow: 0 } },
                { text: "Heavy, bloated, or uncomfortable", scores: { calocurb: 0, sculpt: 0, gutglow: 1 } },
                { text: "Satisfied and steady", scores: { calocurb: 0, sculpt: 0, gutglow: 0 } }
            ]
        },
        {
            id: 3,
            question: "What best describes your cravings?",
            image: "https://cdn.shopify.com/s/files/1/0053/0097/7710/files/4.jpg?v=1772138062",
            options: [
                { text: "They come on fast and take over; once I start, I can't stop", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "They feel mental; food chatter, stress, reward-seeking", scores: { calocurb: 0, sculpt: 2, gutglow: 0 } },
                { text: "I crave comfort foods when my belly feels unsettled", scores: { calocurb: 0, sculpt: 0, gutglow: 1 } },
                { text: "They're mild or rare", scores: { calocurb: 0, sculpt: 0, gutglow: 0 } }
            ]
        },
        {
            id: 4,
            question: "Which hunger pattern feels most like you?",
            image: "https://cdn.shopify.com/s/files/1/0053/0097/7710/files/3.jpg?v=1772138062",
            options: [
                { text: "I get hungry again shortly after meals", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "I snack to relieve stress, anxiety, or overwhelm", scores: { calocurb: 0, sculpt: 2, gutglow: 0 } },
                { text: "I feel bloated or gassy, even with lighter meals", scores: { calocurb: 0, sculpt: 0, gutglow: 1 } },
                { text: "My appetite feels normal", scores: { calocurb: 0, sculpt: 0, gutglow: 0 } }
            ]
        },
        {
            id: 5,
            question: "What triggers your cravings the most?",
            image: "https://cdn.shopify.com/s/files/1/0053/0097/7710/files/7.jpg?v=1772138062",
            options: [
                { text: "Seeing food — buffets, appetizers, dessert tables", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "Brain overload — long workdays, stress, or emotional intensity", scores: { calocurb: 0, sculpt: 2, gutglow: 0 } },
                { text: "Belly discomfort — sluggish digestion, bloating", scores: { calocurb: 0, sculpt: 0, gutglow: 1 } },
                { text: "Sugar crashes, tiredness, or low energy", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } }
            ]
        },
        {
            id: 6,
            question: "When you're out to dinner or at a party, what usually happens?",
            image: "https://cdn.shopify.com/s/files/1/0053/0097/7710/files/6.jpg?v=1772138062",
            options: [
                { text: "I eat more than planned; social situations trigger me", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "I want something sweet after the meal", scores: { calocurb: 0, sculpt: 2, gutglow: 0 } },
                { text: "I feel bloated or uncomfortable after eating", scores: { calocurb: 0, sculpt: 0, gutglow: 1 } },
                { text: "I stay in control most of the time", scores: { calocurb: 0, sculpt: 0, gutglow: 0 } }
            ]
        },
        {
            id: 7,
            question: "How would you describe your belly on a typical day?",
            image: "https://cdn.shopify.com/s/files/1/0053/0097/7710/files/5.jpg?v=1772138063",
            options: [
                { text: "It's fine; my cravings feel more mental", scores: { calocurb: 0, sculpt: 2, gutglow: 0 } },
                { text: "I'm always hungry or never fully satisfied", scores: { calocurb: 3, sculpt: 0, gutglow: 0 } },
                { text: "I feel bloated, gassy, or heavy regularly", scores: { calocurb: 0, sculpt: 0, gutglow: 1 } },
                { text: "Pretty normal", scores: { calocurb: 0, sculpt: 0, gutglow: 0 } }
            ]
        }
    ];



    function initQuizInstance(root) {
        const startBtn = root.querySelector('#start-quiz');
        const closeBtn = root.querySelector('#close-quiz');
        const restartBtn = root.querySelector('#restart-quiz');
        const leadForm = root.querySelector('#quiz-lead-form');
        const steps = root.querySelectorAll('.quiz-step');
        const progressFill = root.querySelector('#progress-fill');
        const questionNumber = root.querySelector('#question-number');
        const questionText = root.querySelector('#question-text');
        const optionsContainer = root.querySelector('#options-container');
        const imagePanel = root.querySelector('#question-image');
        const nextBtn = root.querySelector('#next-btn');
        const prevBtn = root.querySelector('#prev-btn');
        const prevToQ = root.querySelector('#prev-to-q');
        const resultCardContainer = root.querySelector('#result-product-card');

        let currentStep = 0;
        let selectedPerStep = new Array(8).fill(null);

        function resetQuiz() {
            currentStep = 0;
            selectedPerStep = new Array(8).fill(null);
            showStep(0);
        }

        function showStep(logicalIndex) {
            currentStep = logicalIndex;
            let pIndex = 0;
            if (logicalIndex >= 1 && logicalIndex <= 7) pIndex = 1;
            else if (logicalIndex === 8) pIndex = 2;
            else if (logicalIndex === 9) pIndex = 3;

            steps.forEach((step, i) => {
                step.style.display = (i === pIndex) ? 'flex' : 'none';
                if (i === pIndex) step.classList.add('active');
            });

            if (logicalIndex >= 1 && logicalIndex <= 7) {
                renderQuestion(logicalIndex - 1);
                updateProgress(logicalIndex);
                prevBtn.style.visibility = (logicalIndex > 1) ? 'visible' : 'hidden';
                updateNextButtonState();
            } else {
                updateProgress(logicalIndex === 8 ? 7.5 : (logicalIndex === 9 ? 8 : 0));
            }
        }

        function renderQuestion(qIndex) {
            const qData = quizData[qIndex];
            questionNumber.innerText = qData.id + ')';
            questionText.innerText = qData.question;
            imagePanel.innerHTML = `<img src="${qData.image}" alt="Solaris Quiz">`;

            optionsContainer.innerHTML = '';
            qData.options.forEach((opt, i) => {
                const btn = document.createElement('div');
                btn.className = 'quiz-option';
                if (selectedPerStep[currentStep] === i) btn.classList.add('selected');

                const letter = String.fromCharCode(65 + i);
                btn.innerHTML = `<span class="opt-letter">${letter}</span> <span class="opt-text">${opt.text}</span>`;

                btn.addEventListener('click', () => {
                    selectedPerStep[currentStep] = i;
                    Array.from(optionsContainer.children).forEach(c => c.classList.remove('selected'));
                    btn.classList.add('selected');
                    updateNextButtonState();
                });
                optionsContainer.appendChild(btn);
            });
        }

        function updateNextButtonState() {
            if (!nextBtn) return;
            nextBtn.disabled = (selectedPerStep[currentStep] === null);
            nextBtn.style.opacity = nextBtn.disabled ? '0.2' : '1';
        }

        function updateProgress(step) {
            if (!progressFill) return;
            const total = 8;
            const percent = (step / total) * 100;
            progressFill.style.width = percent + '%';
        }

        if (nextBtn) nextBtn.addEventListener('click', () => {
            if (currentStep < 7) showStep(currentStep + 1);
            else showStep(8);
        });

        if (prevBtn) prevBtn.addEventListener('click', () => showStep(currentStep - 1));
        if (prevToQ) prevToQ.addEventListener('click', () => showStep(7));
        if (startBtn) startBtn.addEventListener('click', () => showStep(1));
        if (restartBtn) restartBtn.addEventListener('click', resetQuiz);

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                root.classList.remove('open');
                setTimeout(() => root.style.display = 'none', 300);
            });
        }

        // Keyboard Navigation (Enter key) - Improved global listener
        document.addEventListener('keydown', (e) => {
            // Only trigger if this specific quiz instance is visible
            if (root.style.display === 'none' || (root.classList && !root.classList.contains('open') && root.id !== 'quiz-section-root')) return;

            if (e.key === 'Enter') {
                if (e.target.tagName === 'INPUT') return;
                if (nextBtn && !nextBtn.disabled && nextBtn.style.visibility !== 'hidden') {
                    nextBtn.click();
                    e.preventDefault();
                } else if (currentStep === 0 && startBtn) {
                    startBtn.click();
                    e.preventDefault();
                }
            }
        });

        if (leadForm) {
            leadForm.addEventListener('submit', async (e) => {
                e.preventDefault();

                const submitBtn = leadForm.querySelector('button[type="submit"]');
                submitBtn.innerText = "Processing...";
                submitBtn.disabled = true;

                let scores = { calocurb: 0, sculpt: 0, gutglow: 0 };
                for (let i = 1; i <= 7; i++) {
                    const choiceIdx = selectedPerStep[i];
                    if (choiceIdx !== null) {
                        const opt = quizData[i - 1].options[choiceIdx];
                        scores.calocurb += opt.scores.calocurb || 0;
                        scores.sculpt += opt.scores.sculpt || 0;
                        scores.gutglow += opt.scores.gutglow || 0;
                    }
                }

                const { calocurb: c, sculpt: s, gutglow: g } = scores;
                let resultOutcome = "";
                if (c > s && s >= 4 && (c - s) <= 2) resultOutcome = "Calocurb® + Sculpt™";
                else if (s > g && g >= 2 && (s - g) <= 1) resultOutcome = "Sculpt™ + GutGlow™";
                else {
                    const max = Math.max(c, s, g);
                    if (c === s && s === g) resultOutcome = "Sculpt™";
                    else if (c === s && c === max) resultOutcome = "Calocurb®";
                    else if (s === g && s === max) resultOutcome = "Sculpt™";
                    else if (c === g && c === max) resultOutcome = "Calocurb®";
                    else if (c === max) resultOutcome = "Calocurb®";
                    else if (s === max) resultOutcome = "Sculpt™";
                    else resultOutcome = "GutGlow™";
                }

                const handle = window.quizOutcomeMap[resultOutcome];
                const product = window.quizProductData[handle];

                try {
                    const nameInput = root.querySelector('#quiz-name');
                    const emailInput = root.querySelector('#quiz-email');
                    const phoneInput = root.querySelector('#quiz-phone');

                    const userName = nameInput ? nameInput.value.trim() : "";
                    const nameParts = userName.split(" ");
                    const firstName = nameParts[0] || "";
                    const lastName = nameParts.slice(1).join(" ") || "";
                    const userEmail = emailInput ? emailInput.value.trim() : "";
                    const userPhone = phoneInput ? phoneInput.value.trim() : "";
                    const recommendedProductName = product ? product.title : resultOutcome;

                    // Tag/Segment Mapping
                    let productTag = "";
                    const lowerResult = resultOutcome.toLowerCase();
                    if (lowerResult.includes("calocurb") && lowerResult.includes("sculpt")) productTag = "quiz-solfuel-sculpt-calocurb-duo";
                    else if (lowerResult.includes("sculpt") && lowerResult.includes("gutglow")) productTag = "quiz-solfuel-sculpt-gutglow-duo";
                    else if (lowerResult.includes("calocurb")) productTag = "quiz-calocurb";
                    else if (lowerResult.includes("sculpt")) productTag = "quiz-solfuel-sculpt";
                    else if (lowerResult.includes("gutglow")) productTag = "quiz-solfuel-gutglow";

                    // --- OMNISEND INTEGRATION (COMMENTED OUT) ---
                    /*
                    // Robust Script Detection (v1.3)
                    const omni = window.omnisend || window._omnisend || window.omnisendQueue || [];

                    // 1. Identification Payload (Now including Contact Properties for Segments)
                    const identifyPayload = {
                        email: userEmail,
                        firstName: firstName,
                        lastName: lastName,
                        quiz_segment: productTag,
                        quiz_result: resultOutcome
                    };
                    if (userPhone) identifyPayload.phone = userPhone;

                    console.log("Omnisend Identify Payload (v1.3):", identifyPayload);

                    // Unified identification for compatibility (v1.3)
                    if (typeof omni.identifyContact === 'function') {
                        omni.identifyContact(identifyPayload);
                    } else if (typeof omni.push === 'function') {
                        omni.push(["identify", identifyPayload]);
                    }

                    // 2. Track with 500ms delay to prevent race condition (v1.3)
                    setTimeout(() => {
                        const trackPayload = {
                            quiz_result: resultOutcome,
                            recommended_product: recommendedProductName,
                            quiz_segment: productTag,
                            quiz_answers: selectedPerStep.slice(1, 8),
                            quiz_version: "v1.3"
                        };

                        console.log("Omnisend Track Payload (v1.3):", trackPayload);

                        if (typeof omni.track === 'function') {
                            omni.track("Quiz Completed", trackPayload);
                        } else if (typeof omni.push === 'function') {
                            omni.push(["track", "Quiz Completed", trackPayload]);
                        }
                    }, 500);

                    console.log("Omnisend submission sequence (v1.3) initiated.");
                    */

                    // --- KLAVIYO INTEGRATION ---
                    const klaviyoProductUrl = (product && product.url) ? `https://solarispremium.com${product.url}` : 'https://solarispremium.com/collections/all';

                    const klaviyoIdentifyPayload = {
                        $email: userEmail,
                        $first_name: firstName,
                        $last_name: lastName,
                        quiz_result: resultOutcome,
                        quiz_product_url: klaviyoProductUrl, 
                        $source: "Quiz Popup",
                        Tags: ["Quiz Lead", productTag], // Use standard "Tags" for Klaviyo tag-based segmentation
                        "Shopify Tags": ["Quiz Lead", productTag] // Fallback standard Shopify Tag naming
                    };
                    // Only add phone if it's not empty
                    if (userPhone) klaviyoIdentifyPayload.$phone_number = userPhone;

                    const _learnq = window._learnq || [];

                    // 1. Identify User in Klaviyo
                    _learnq.push(['identify', klaviyoIdentifyPayload]);

                    // 2. Track Event in Klaviyo (Delayed)
                    setTimeout(() => {
                        const klaviyoTrackPayload = {
                            quiz_result: resultOutcome,
                            recommended_product: recommendedProductName,
                            quiz_product_url: klaviyoProductUrl,
                            quiz_segment: productTag,
                            quiz_answers: selectedPerStep.slice(1, 8)
                        };

                        _learnq.push(['track', 'Quiz Completed', klaviyoTrackPayload]);
                        console.log("Klaviyo submission sequence initiated:", klaviyoIdentifyPayload);
                    }, 500);

                } catch (integErr) {
                    console.error("Integration Logic Error:", integErr);
                }

                await new Promise(resolve => setTimeout(resolve, 2000));


                // 3. Attribution in Redirection
                let targetUrl = (product && product.url) ? product.url : '/collections/all';
                let productTagUrl = "";
                const lowerResultRedir = resultOutcome.toLowerCase();
                if (lowerResultRedir.includes("calocurb") && lowerResultRedir.includes("sculpt")) productTagUrl = "quiz-solfuel-sculpt-calocurb-duo";
                else if (lowerResultRedir.includes("sculpt") && lowerResultRedir.includes("gutglow")) productTagUrl = "quiz-solfuel-sculpt-gutglow-duo";
                else if (lowerResultRedir.includes("calocurb")) productTagUrl = "quiz-calocurb";
                else if (lowerResultRedir.includes("sculpt")) productTagUrl = "quiz-solfuel-sculpt";
                else if (lowerResultRedir.includes("gutglow")) productTagUrl = "quiz-solfuel-gutglow";

                if (productTagUrl) {
                    targetUrl += (targetUrl.includes('?') ? '&' : '?') + "quiz_result=" + productTagUrl;
                }

                window.location.href = targetUrl;
            });
        }
    }

    const popupOverlay = document.getElementById('quiz-popup-overlay');
    const standaloneRoot = document.getElementById('quiz-section-root');

    if (popupOverlay) {
        initQuizInstance(popupOverlay);
        document.querySelectorAll('#open-quiz').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                popupOverlay.style.display = 'flex';
                setTimeout(() => popupOverlay.classList.add('open'), 10);
            });
        });
    }

    if (standaloneRoot) {
        initQuizInstance(standaloneRoot);
    }
});
